import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function PaymentSuccess() {
  const { L, clearCart } = useStore();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("missing");
      return;
    }
    let stop = false;
    const poll = async () => {
      while (!stop && tries.current < 14) {
        try {
          const r = await fetch(process.env.REACT_APP_BACKEND_URL + `/api/payments/status/${sessionId}`);
          if (r.ok) {
            const d = await r.json();
            if (d.payment_status === "paid") {
              setStatus("paid");
              clearCart();
              return;
            }
          }
        } catch {}
        tries.current += 1;
        await new Promise((res) => setTimeout(res, 2500));
      }
      if (!stop) setStatus("pending_long");
    };
    poll();
    return () => {
      stop = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="pt-40 pb-32 min-h-screen flex flex-col items-center justify-center text-center px-5" data-testid="payment-success-page">
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 text-gold" strokeWidth={1.2} />
          <h1 className="font-display text-4xl text-ivory mt-6">{L.pay.successTitle}</h1>
          <p className="text-sand text-sm max-w-md mt-4 leading-relaxed">{L.pay.successMsg}</p>
        </>
      )}
      {(status === "pending" || status === "pending_long") && (
        <>
          <Loader2 className="w-14 h-14 text-gold animate-spin" strokeWidth={1.2} />
          <h1 className="font-display text-3xl text-ivory mt-6">{L.pay.pending}</h1>
          {status === "pending_long" && <p className="text-sand text-sm max-w-md mt-4 leading-relaxed">{L.pay.pendingLong}</p>}
        </>
      )}
      {status === "missing" && (
        <>
          <XCircle className="w-14 h-14 text-gold" strokeWidth={1.2} />
          <h1 className="font-display text-3xl text-ivory mt-6">{L.pay.notFound}</h1>
        </>
      )}
      <Link to="/shop" data-testid="payment-success-back" className="btn-gold rounded-full px-8 py-3.5 text-[0.7rem] tracking-[0.25em] uppercase font-semibold mt-10">
        {L.pay.backToShop}
      </Link>
    </div>
  );
}
